import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { LoginService } from 'src/app/common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';

@Component({
  selector: 'app-right-overlay',
  templateUrl: './right-overlay.component.html',
  styleUrls: ['./right-overlay.component.css'],
  animations:[
    trigger('slideInOut',[
      state('in', style({
        transform : 'translate3d(0,0,0)',
        opacity : 1,
      })),
      state('out', style({
        transform : 'translate3d(10%,0,0)',
        opacity : 0,
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ])
  ]
})
export class RightOverlayComponent implements OnInit {

  @HostListener('document:keydown', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (event.key === "Escape" && this.isPopUpOpen == false) {
      if (this.overlayOption != 'Terms And Conditions' && this.overlayOption != 'Logout Users') {
        this.overlayState = "out";
        setTimeout(() => {
          this.showOverlay = false;
        }, 400)
      }
    }
  }

  @HostListener('document:mousewheel', ['$event'])
  onDocumentMousewheelEvent(event) {
    var div = document.getElementById('printscroll');
    if(div){
      var vs = div.scrollHeight > div.clientHeight;
      if (vs) {
        document.getElementById("topLoad").style.display = "";
      }
      else {
        document.getElementById("topLoad").style.display = "none";
      }
      this.titleService.setTitle(document.title)
    }
  }


  constructor(
    private elementref:ElementRef,
    public commonDataService : CommonDataService,
    public configurationServce : ConfigurationService,
    public _loginservice: LoginService,
    public sanitizer: DomSanitizer,
    private route: Router,
    private graphQlService: GraphqlService,
    private titleService: Title
  ) { } 

  printBreadcrumb: boolean = true;
  showOverlay : boolean = false;
  overlayState : string = "out";
  contentWidth : string = "50%";
  currentParagraph: string;
  isShowAllInOnePage: boolean = false;
  overlayOption: string;
  previewFileName: string = "";
  isRightOverlayContentPage:boolean;
  isRightOverlayPendingContentPage: boolean = false;
  navData = {
    crumbData : [],
  };
  closeModalBool: boolean;
  logo
  isPopUpOpen: boolean;
  PageData:any;
  PendingContentPageData = {
    pubId: "",
    pageId: "",
    paraId: ""
  };
  viewFullScreen:boolean=true;
  paraId:string;
  crossRefReportGenerated:boolean;
  childComponent:boolean=false;
  searchContentLink:string="";
  searchContentBreadCrumbPath:string="";
  glossaryTermData: any = [];
  mainsectionname: string = "";
  sectionname: string = "";
  TargetDivId: string;
  contentPaddingValue: string;
  docTitle: string;
  dateNow: string;
  year: string;
  ngOnInit(): void {
    console.log(document.title);
     
    this.previewFileName = "";
    this.commonDataService.showRightPanel.subscribe(data => {
      if (data) {
        this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
        this.year = new Date().getFullYear().toString();
        this.showOverlay = true;
        this.docTitle = document.title;
        setTimeout(()=>{
          this.overlayState = "in";
        }, 40)
        if (this.route.url.includes('showallinonepage')) {
          this.isShowAllInOnePage = true;
          this.mainsectionname = document.getElementById("main-section-name").innerHTML;
          this.sectionname = document.getElementById("section-name").innerHTML;
        }
        else {
          this.isShowAllInOnePage = false;
        }

        if (this.route.url == "/about-us" || this.route.url.includes("/tableOfContent") || this.route.url == "/copy-right" || this.route.url == "/terms-and-conditions" || this.route.url.includes("/help") || this.route.url.includes("/MasterGlossary") || this.route.url.includes("/relatedproposedasus") || this.route.url.includes("/pcsfaq")) {
          this.printBreadcrumb = false;
          this.contentPaddingValue = "padding-right-general-page"
        }
        else if (document.getElementsByClassName('print-all-content').length > 0 && document.getElementsByClassName('print-all-content')[0].parentElement.nodeName === 'APP-OTHERSOURCE-CONTENT-VIEWER') {
          this.contentPaddingValue = "padding-right-general-page"
        }
        else {
          this.printBreadcrumb = true;
          this.contentPaddingValue = "padding-right-content-page"
        }
      }
      // this.navData = JSON.parse(JSON.stringify(this.commonDataService.navData.getValue()));
      // this.checkHome();
    })
    this.commonDataService.rightPanelWidth.subscribe(data => {
      let str  = data;
      this.contentWidth = this.configurationServce[str];
    })

    this.commonDataService.rightOverlayOption.subscribe(data => {
      this.overlayOption = data;
      if(this.overlayOption=="ContentPage"){
        this.isRightOverlayContentPage=true;
      }
      if (this.overlayOption == "PendingContentviewer") {
        this.isRightOverlayPendingContentPage=true;
      } 
    })

    this.commonDataService.isConfirmationPopUpOpen.subscribe(data => {
      this.isPopUpOpen = data;
    })
    this.commonDataService.TargetDivId.subscribe(data => {

      this.TargetDivId = data;
    })
    this.commonDataService.childComponent.subscribe(data => {
      this.childComponent = data;
    })
    // this.commonDataService.currentParagraph.subscribe(data => {
    //   this.currentParagraph = data;
    // })

    // this.navData = JSON.parse(JSON.stringify(this.commonDataService.navData.getValue()));

    // this.checkHome();
    this.commonDataService.closeModalOption.subscribe(data => {
      this.closeModalBool = data;
    })

    this.loadLogo()

    this.commonDataService.printpreviewFileName.subscribe(data => {
      this.previewFileName = data;
    })

    this.commonDataService.rightOverlayContentPageID.subscribe(data => {
      this.PageData = ["1141285", "1112451", "919242", "Overview and Background"];
      this.PageData = data;
    })
    this.commonDataService.rightOverlayPendingContentData.subscribe(data => {
      this.PendingContentPageData = { pubId: data.pubId, pageId: data.pageId, paraId: data.paraId};
    })

    this.commonDataService.crossreferencedParaID.subscribe(data => {
      this.paraId = data?.paragraphID;
    })
    this.commonDataService.searchContentLink.subscribe(data=>{
      this.searchContentLink=data;
    })
    this.commonDataService.searchContentBreadCrumbPath.subscribe(data=>{
      this.searchContentBreadCrumbPath=data;
    })

    this.commonDataService.glossaryTermData.subscribe(termData=>{
      this.glossaryTermData=termData;
    })

    this.commonDataService.glossaryTermId.subscribe(termId=>{
      this.glossaryTermId=termId;
    })
    this.commonDataService.CrossRefReportNotGenerated.subscribe(data=>{
      this.crossRefReportGenerated=data;
      this.overlayState = "out";
    setTimeout(() => {
      this.showOverlay = false;
    }, 400);
    })

  }

  contents: string[] = [];
  pageHeading: string;
  injectData(contents,pageHeading) {
    this.contents = contents;
    this.pageHeading = pageHeading;
  }
  checkHome(){
    if(this.navData.crumbData.length === 0){
      this.navData.crumbData.push("Home")
    }
  }

  startAnimation(){
  }

  animationDone(){
  }

  overlayClicked(){

  }

  overlayContentClicked(){
  }
  popstateClick(event) {
    if (event == "Broswer Back Button click") {
      this.closeRightOverlay(); this.closeOverlayAnnotation(); this.closeOverlay(); this.closeOverlayPrintPreview(); this.closeOverlayBookmark()
    }
  }

  closeOverlay(){
    this.overlayState = "out";
      setTimeout(()=>{
        this.showOverlay = false;
        this.commonDataService.annotationContent.next(null);
        this.commonDataService.childComponent.next(false);
        this.commonDataService.glossaryParentGuid.next([]);
      },400)
    this.commonDataService.showRightPanel.next(false);
    this.commonDataService.NavigatingFromComponent.next("");
    this.commonDataService.rightOverlayPendingContentData.next({pubId:"",pageId:"",paraId:""});
    this.glossaryTermId="";
    var loginHome = Array.from(document.getElementsByClassName('main-login-container') as HTMLCollectionOf<HTMLElement>);
    loginHome.forEach(x => {
      x.style.overflow = 'auto';
    });
  }
  closeOverlayPrintPreview() {
    if (this.previewFileName == "PP_withallannotations") {
      this.commonDataService.displayallannotation.next("hidePrintallannotations");
    }
    if (this.previewFileName == "PP_withallsources") {

      if(this.route.url=="/MasterGlossary" && sessionStorage.getItem("asc_displayAllSources")!='true'){
        this.commonDataService.glossaryShowSource.next(false);
      }
    }
    this.commonDataService.printContentHideShow.next("Hide");
    this.overlayState = "out";
    setTimeout(() => {
      this.showOverlay = false;
      this.commonDataService.annotationContent.next(null);
    }, 1000)
  }

  closeOverlayAnnotation() {
    this.overlayState = "out";
    setTimeout(() => {
      this.showOverlay = false;
      this.commonDataService.annotationContent.next(null);
    }, 400)
  }

  closeRightOverlay() {
    this.overlayState = "out";
    setTimeout(() => {
      this.showOverlay = false;
    }, 400);

    var loginHome = Array.from(document.getElementsByClassName('main-login-container') as HTMLCollectionOf<HTMLElement>);
    loginHome.forEach(x => {
      x.style.overflow = 'auto';
    });
    this.commonDataService.NavigatingFromComponent.next("");
    this.commonDataService.rightOverlayPendingContentData.next({pubId:"",pageId:"",paraId:""});
    this.glossaryTermId="";
  }

  closeOverlayBookmark() {
  this.overlayState = "out";
  setTimeout(() => {
    this.showOverlay = false;
    //this.commonDataService.bookmarkId.next(null);
  }, 400)
}
  loadLogo() {
    this.graphQlService.getS3BucketImageASCLogo().subscribe(data => {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(data);
    });
  }

  gotoSection() {
    document.getElementById('scrollToTop').scrollIntoView();
  }

  openFullscreen(){
    this.contentWidth="83.3%";
    this.viewFullScreen=false;
  }
  closeFullscreen()
  {
    this.contentWidth="50%";
    this.viewFullScreen=true;
    if(this.overlayOption=="searchPage")
    {
      this.contentWidth="26.8%";
    }
  }
  glossaryTermId:string="";
  viewPreviousScreen(){
    let component=this.commonDataService.NavigatingFromComponent.getValue();
    let isGlossaryFromCrossReference=this.commonDataService.glossaryFromCrossReference.getValue();
    let currentComponent=this.commonDataService.rightOverlayOption.getValue();
    if(currentComponent!="inline-glossary" && component!="PendingContentviewer"){
      this.commonDataService.NavigatingFromComponent.next('');
    }
    
    if(component!=""){
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next(component);
        this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        if(component=="searchPage"|| component=="inline-glossary")
        {
          this.commonDataService.rightPanelWidth.next("rightOverLay_small");
          this.childComponent =this.commonDataService.glossaryParentGuid.getValue().length==0?false: true;
        }
    }
    if(isGlossaryFromCrossReference && component=="inline-glossary"){
      this.commonDataService.NavigatingFromComponent.next("ContentPage");
      this.commonDataService.childComponent.next(true);
      this.childComponent = true;
    }else if(component=="inline-glossary"){
      this.childComponent =this.commonDataService.glossaryParentGuid.getValue().length==0?false: true;
    }
    else{
      this.commonDataService.childComponent.next(false);
      this.childComponent = false;
    }
    if ((component=="" || component=="PendingContentviewer") && this.commonDataService.glossaryParentGuid.getValue().length > 0) {
      this.glossaryTermId="";
      this.commonDataService.glossaryTermId.next(this.commonDataService.glossaryParentGuid.getValue().pop());
      this.glossaryTermId=this.commonDataService.glossaryTermId.getValue();
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.rightOverlayOption.next("inline-glossary");
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.childComponent =this.commonDataService.glossaryParentGuid.getValue().length==0 && component!="PendingContentviewer"?false: true;
      this.commonDataService.childComponent.next(this.childComponent);
    }
  }
}
